/* eslint-disable import/prefer-default-export */
export const CONFIG = {
  'ca-ui': {
    name: 'ca-ui',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/ca?app=CREDITAPP',
    childRoutes: ['ca'],
    position: '#ca-ui',
    fileLocation: '/ca-ui/',
    shared: ['ca-idealease-ui'],
  },
  'ca-idealease-ui': {
    name: 'ca-idealease-ui',
    loaded: false,
    permitted: false,
    childRoutes: [],
    pathRelativeToPortal: '#/ca?app=IDEALEASECREDITAPP',
    position: '#ca-ui',
    fileLocation: '/ca-ui/',
    shared: ['ca-ui'],
  },
  'dmc-ui': {
    name: 'dmc-ui',
    loaded: false,
    permitted: false,
    childRoutes: ['takedown', 'esign', 'esign-documents'],
    pathRelativeToPortal: '#/dmc',
    position: '#dmc-ui',
    fileLocation: '/dmc-ui/',
  },
  'salesrep-ui': {
    name: 'salesrep-ui',
    loaded: false,
    permitted: false,
    childRoutes: [],
    pathRelativeToPortal: '#/salesrep',
    position: '#salesrep-ui',
    fileLocation: '/salesrep-ui/',
    shared: ['emulate-salesrep-ui'],
  },
  'emulate-salesrep-ui': {
    name: 'salesrep-ui',
    loaded: false,
    permitted: false,
    childRoutes: [],
    pathRelativeToPortal: '#/salesrep/emulate-dealer',
    position: '#salesrep-ui',
    fileLocation: '/salesrep-ui/',
    shared: ['salesrep-ui'],
  },
  'admin-ui': {
    name: 'admin-ui',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/admin',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['inter-admin-ui', 'user-admin', 'business-segment', 'manage-content', 'eapps-admin', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'inter-admin-ui': {
    name: 'inter-admin-ui',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/inter-admin',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'user-admin', 'business-segment', 'manage-content', 'eapps-admin', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'user-admin': {
    name: 'user-admin',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/user-admin',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'business-segment', 'manage-content', 'eapps-admin', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'business-segment': {
    name: 'business-segment',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/business-segment',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'manage-content', 'eapps-admin', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'manage-content': {
    name: 'manage-content',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/manage-content',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'business-segment', 'eapps-admin', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'eapps-admin': {
    name: 'eapps-admin',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/eapps-admin',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'business-segment', 'manage-content', 'select-salesreps', 'profile', 'manage-salesrep'],
  },
  'select-salesreps': {
    name: 'select-salesreps',
    loaded: false,
    permitted: true,
    pathRelativeToPortal: '#/select-salesreps',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'business-segment', 'manage-content', 'eapps-admin', 'profile', 'manage-salesrep'],
  },
  profile: {
    name: 'profile',
    loaded: false,
    permitted: false,
    pathRelativeToPortal: '#/profile',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'business-segment', 'manage-content', 'eapps-admin', 'select-salesreps', 'manage-salesrep'],
  },
  'manage-salesrep': {
    name: 'manage-salesrep',
    loaded: false,
    permitted: false,
    childRoutes: [],
    pathRelativeToPortal: '#/inter-admin/add-salesreps',
    position: '#admin-ui',
    fileLocation: '/admin-ui/',
    shared: ['admin-ui', 'inter-admin-ui', 'user-admin', 'business-segment', 'manage-content', 'eapps-admin', 'select-salesreps', 'profile'],
  },
  reports: {
    name: 'reports',
    loaded: false,
    permitted: false,
    childRoutes: [],
    pathRelativeToPortal: '#/reports',
    position: '#reports',
    fileLocation: '/reports/',
  },
  'pe-ui': {
    name: 'pe-ui',
    loaded: false,
    permitted: false,
    childRoutes: ['pe'],
    pathRelativeToPortal: '#/pe',
    position: '#pe-ui',
    fileLocation: '/pe-ui/',
  },
};
